import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=45152ede&"
import script from "./AutoComplete.vue?vue&type=script&lang=ts&"
export * from "./AutoComplete.vue?vue&type=script&lang=ts&"
import style0 from "./AutoComplete.vue?vue&type=style&index=0&id=45152ede&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports